<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="sidebar-title is-size-5 pb-4">Create User</div>
    <form @submit.prevent="submit" novalidate>
      <c-text-input v-model="data.email" label="Email" type="email" :error="errors.email"/>
      <c-text-input v-model="data.password" label="Password" type="password" autocomplete="new-password"
                    :error="errors.password"/>
      <!-- requested to show "roles" here not to create role system on backend, but instead a superadmin flag -->
      <c-select-input v-if="editor.is_superadmin" v-model="data.role" label="Role"
                      :options="{user: 'user', admin: 'admin', superadmin: 'superadmin'}"/>
      <c-select-input v-else v-model="data.role" label="Role"
                      :options="{user: 'user', admin: 'admin'}"/>
      <div class="pt-5">
        <button class="button is-primary is-fullwidth">Create</button>
      </div>
    </form>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
import { get } from 'vuex-pathify';
import api from '@/api';


export default {
  name: 'create-user-form',
  data () {
    return {
      data: {
        role: 'user',
        is_superuser: false
      },
      errors: {}
    };
  },
  computed: {
    editor: get('user'),
  },
  methods: {
    save(dump) {
      var blob = new Blob([JSON.stringify(dump, null, 2)], {type: "text/plain;charset=utf-8"});
      saveAs(blob, `${dump.id}.json`);
    },
    async submit() {
      try {
        const dump = await api.admin.users.create(this.data);
        this.save(dump);
        this.errors = {};
        this.data = {};
        this.$emit('complete');
      } catch (error) {
        this.handle(error);
      }
    },
    handle(error) {
      const errors = error.data;
      this.errors = {};
      if (errors.email)
        this.errors.email = 'Please enter a valid unique email address.';
      if (errors.password)
        this.errors.password = 'Please enter a password with numbers, letters, capitols and at least 8 characters.';
      if (errors.is_superuser)
        this.errors.is_superuser = "There was a problem setting this user's admin status.";
    }
  }
};
</script>
